import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID,  AfterViewInit, ChangeDetectorRef, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MapService } from '@app/services/map.service';
export interface DialogData<T> {
    poi: T;
    name: string;
}

@Component({
    selector: 'app-mapcomponent',
    templateUrl: './mapcomponent.component.html',
    styleUrls: ['./mapcomponent.component.scss'],
    standalone: false
})
export class MapcomponentComponent implements AfterViewInit {
    title = '';
    // protected Leaflet = null;
    protected map = null;
    protected showMap: boolean = false;

    destroyRef = inject(DestroyRef);

    constructor(
        @Inject(MAT_DIALOG_DATA) protected data: DialogData<any>,
        @Inject(PLATFORM_ID) protected platformId: Object,
        protected mapService: MapService,
        protected cdr: ChangeDetectorRef,
    ) { }

    ngAfterViewInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.mapService.Leaflet$.pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe(Leaflet => {
                if (Leaflet) {
                    this.onMapReady();
                }
            });
        }
    }

    onMapReady() {
        if (isPlatformBrowser(this.platformId)) {
            this.map = this.mapService.Leaflet.map('map').setView([this.data?.poi?.location?.latitude, this.data?.poi?.location?.longitude], 15);
            this.mapService.Leaflet.tileLayer('https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' }).addTo(this.map);
            this.map?.invalidateSize();
            this.initMaps();
        }
    }

    initMaps() {
        this.title = this.data.poi.name;

        this.mapService.Leaflet.marker([Number(this.data?.poi?.location?.latitude), Number(this.data?.poi?.location?.longitude)],
            {
                icon: this.mapService.Leaflet.icon({
                    iconSize: [25, 41],
                    iconAnchor: [13, 41],
                    iconUrl: 'leaflet/marker-icon.png',
                    shadowUrl: 'leaflet/marker-shadow.png'
                })
            }
        ).bindPopup(this.data.poi.name).addTo(this.map);
        this.map?.invalidateSize();
        this.showMap = true;
        this.cdr.detectChanges();
    }
}
